import React, { useEffect } from 'react'
import { useUser } from '@/context/UserProvider'
import PropTypes from 'prop-types'
import { isEnabled } from '@/constants/features'

export const WebAppRedirect = ({ children }) => {
    const { user, hasPermission, isLoadingPermissions } = useUser()

    useEffect(() => {
        if (
            window !== undefined &&
            isEnabled('web-app-redirect') &&
            user &&
            hasPermission &&
            !isLoadingPermissions
        ) {
            const origin = window.location.origin
            const domainsThatShouldRedirect = [
                '.dk',
                '.de',
                '.hr',
                '.fr',
                '.co.uk',
                '.nl',
                '.es',
                '.it',
                '.be',
                '.no',
                '.se',
                '.at',
                '.ch',
                '.pl',
                '.si',
                '.com',
            ]
            const userAgent = navigator.userAgent.toLowerCase()
            const search = location.search.toLowerCase()
            
            // Redirect to web app for Novasol users on specific domains
            // Only redirect if in the top window (not in an iframe)
            // Only redirect if the user does NOT have the 'destinationService' permission (i.e., not a DS user)
            // Exclude the AWZ Owner app webview from redirection
            // Exclude if 'isiframe' is present in the URL search params
            if (
                user?.attributes?.brand == 'novasol' &&
                !hasPermission('destinationService') &&
                window.top === window.self &&
                !userAgent.includes('awz-owner-wv') &&
                !search.includes('isiframe') &&
                domainsThatShouldRedirect.some(domain =>
                    origin.endsWith(domain)
                )
            ) {
                window.location.href = `/web-app${window.location.pathname}${window.location.search}`
            }
        }
    }, [user, hasPermission, isLoadingPermissions])

    return <>{children}</>
}

WebAppRedirect.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
}
